import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  WritableSignal,
  signal,
} from '@angular/core';

@Component({
  selector: 'iho-count-down',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.scss'],
})
export class CountDownComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ){}

  @Input() Dates!: {
    countdownDate: any;
    currentDate: any;
  } | null;

  
  @Input() dates!: {
    CountdownDate: any;
    CurrentDate: any;
  } | null;

  @Output() _remainingTime: EventEmitter<Date> = new EventEmitter();

  remainingTimeStatus = signal(1);

  remainingDays = signal(0);
  hours: WritableSignal<number> = signal(0);
  minutes: WritableSignal<number> = signal(0);
  seconds: WritableSignal<number> = signal(0);
  totalSeconds: any;
  currentSeconds: any;
  remainingTime: any;
  countDownInterval: any;
  loading = signal(true)

  ngOnInit(): void {
    this.calculateRemainingTime();
    this.Countdown()
    if (isPlatformBrowser(this.platformId)) {
    this.countDownInterval = setInterval(() => {
      this.Countdown();
      this.loading.set(false)
    }, 1000);
  }
  }

  public calculateRemainingTime() {
    const currentDate: any = new Date(this.Dates?.currentDate ?? this.dates?.CurrentDate);
    const expireDate: any = new Date(this.Dates?.countdownDate ?? this.dates?.CountdownDate);

    const timeDifference = expireDate - currentDate;

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    this.totalSeconds =
      days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds;

    this.currentSeconds = this.totalSeconds;
  }

  Countdown() {
    this.remainingTime = {
      days: Math.floor(this.currentSeconds / (24 * 3600)),
      hours: Math.floor((this.currentSeconds % (24 * 3600)) / 3600),
      minutes: Math.floor((this.currentSeconds % 3600) / 60),
      seconds: this.currentSeconds % 60,
    };

    if (this.currentSeconds > 0) {
      if (this.remainingTime.days >= 1) {
        this.remainingTimeStatus.set(0);
      } else {
        this.remainingTimeStatus.set(1);
      }
    } else {
      clearInterval(this.countDownInterval);
      this.remainingTimeStatus.set(-1);
    }

    this.currentSeconds--;

    this.remainingDays.set(this.remainingTime.days);
    this.hours.set(this.remainingTime.hours);
    this.minutes.set(this.remainingTime.minutes);
    this.seconds.set(this.remainingTime.seconds);
  }
}
